import {
  SUBGENRE_OPTIONS,
  SUBGENRE_REGISTRIES,
} from '../../../data/subgenreRegistry'

/**
 * Derived from data/subgenreRegistry.ts — the single source of truth for the
 * subgenre taxonomy. Do NOT hand-edit this list; add or rename subgenres in the
 * registry and every surface (autocomplete, chips, browse pages) updates.
 */
export const subGenreOptions: Record<string, string[]> = SUBGENRE_OPTIONS

// Re-export the structured registry for the UI
export const STRUCTURED_SUBGENRES = SUBGENRE_REGISTRIES

export const settingOptions = [
  'Contemporary',
  'Historical',
  'Medieval',
  'Victorian',
  'Regency',
  'Modern Day',
  'Urban',
  'Rural',
  'Small Town',
  'Big City',
  'College/University',
  'High School',
  'Workplace',
  'Fantasy World',
  'Space/Sci-Fi',
  'Alternate History',
  'Dystopian',
  'Post-Apocalyptic',
]
export const relationshipDynamics = [
  'Enemies to Lovers',
  'Friends to Lovers',
  'Slow Burn',
  'Second Chance',
  'Forced Proximity',
  'Arranged Marriage',
]
export const relationshipTypes = [
  {
    label: 'M/F',
    description: 'Male/Female',
  },
  {
    label: 'M/M',
    description: 'Male/Male',
  },
  {
    label: 'F/F',
    description: 'Female/Female',
  },
  {
    label: 'MMF',
    description: 'Male/Male/Female',
  },
  {
    label: 'FFM',
    description: 'Female/Female/Male',
  },
  {
    label: 'MMMF',
    description: 'Male/Male/Male/Female',
  },
  {
    label: 'RH',
    description: 'Reverse Harem',
  },
  {
    label: 'Multiple',
    description: 'Multiple Partners',
  },
]
export const tabooSuggestions = [
  'Age Gap',
  'Dubious Consent',
  'Power Imbalance',
  'Step-Relations',
]

export const storyTenseOptions = ['Past Tense', 'Present Tense']

export const endingTypeOptions = [
  'HEA',
  'HFN',
  'Cliffhanger',
  'Bittersweet',
  'Tragic',
  'Open Ending',
]

export const povTypeOptions = ['Single POV', 'Dual POV', 'Multiple POV']

export const themeOptions = [
  'Grief',
  'Identity',
  'Revenge',
  'Healing',
  'Survival',
  'Redemption',
  'Betrayal',
  'Found Family',
  'Coming of Age',
  'Self-Discovery',
  'Forbidden Love',
  'Sacrifice',
  'Power',
  'Corruption',
  'Justice',
  'Freedom',
  'Belonging',
  'Loss',
  'Hope',
  'Obsession',
  'Forgiveness',
  'Legacy',
  'Duty vs Desire',
  'Isolation',
  'Transformation',
  'Trust',
  'War',
  'Class Divide',
  'Morality',
  'Fate vs Free Will',
]

export const formatTypes = [
  { value: 'ebook', label: 'eBook' },
  { value: 'paperback', label: 'Paperback' },
  { value: 'hardcover', label: 'Hardcover' },
  { value: 'audiobook', label: 'Audiobook' },
  { value: 'special-edition', label: 'Special Edition' },
]

export const editionTypes = [
  'Standard',
  'Special',
  'Anniversary',
  'Illustrated',
  "Collector's",
]

export const retailerPlatforms = [
  'Amazon',
  'Kobo',
  'Barnes & Noble',
  'Apple Books',
  'Google Play',
  'Audible',
  'Spotify',
  'Direct Store',
  'Other',
]

export const fileAccessLevels = [
  { value: 'private', label: 'Private (Author Only)' },
  { value: 'arc', label: 'ARC / Early Readers' },
  { value: 'purchasers', label: 'Purchasers Only' },
  { value: 'preview', label: 'Public Preview (Sample)' },
]

export const acceptedFileTypes: Record<string, string[]> = {
  ebook: ['.epub', '.pdf', '.mobi'],
  audiobook: ['.mp3', '.m4a', '.wav'],
  paperback: ['.pdf'],
  hardcover: ['.pdf'],
  'special-edition': ['.epub', '.pdf', '.mobi'],
}

export const youngReaderAgeRanges = [
  { value: 'not-specified', label: 'Not Specified' },
  { value: 'under-13', label: 'Under 13' },
  { value: '13-15', label: '13–15' },
  { value: '16-17', label: '16–17' },
  { value: 'adult-only', label: 'Adult Only' },
]

export const youngReaderMoodTags = [
  'Cozy & Comforting',
  'Adventurous',
  'Funny & Light',
  'Heartfelt',
  'Mysterious',
  'Magical',
  'Brave & Empowering',
  'Thought-Provoking',
  'Spooky (Not Scary)',
  'Wholesome',
]

export const youngReaderStoryTypes = [
  'Coming of Age',
  'Friendship Story',
  'Family Drama',
  'School Life',
  'Quest / Adventure',
  'Animal Companion',
  'Sports Story',
  'Fantasy Quest',
  'Mystery / Detective',
  'Historical Adventure',
  'Sci-Fi Exploration',
  'Fairy Tale Retelling',
]
